// NPM Imports
import React, { useState } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr, Tooltip } from "../../../revvComponents";

// Components Imports
import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";

// Services Imports
import { getSharedDocInPdf } from "../../../actions/SharedDocumentActions/sharedDocumentServices";
import { getSignedDocumentService } from "../../../actions/RevvSign/revvSignService";
import { buttonClickEvent } from "../../../gtm/gtmutils";
import GTM_EVENTS from "../../../gtm/gtmevents";

import { EVENTS, LOADING_MSG } from "../../../constants";
import { AmplitudeUtils } from "../../../utils";
import LZLoader from "../../../commonComponents/LZLoader";
import IconDocumentDownload from "../../../assets/svg/IconDocumentDownload";

const RecipientDocHeaderDownloadButton = ({
  docID,
  docName,
  docStage,
  recipientType,
  isSentForSignature,
  isSharedDocument,
  isMobileView,
  sharingHash,
  usedFor,
  className,
  tooltipPlacement,
  docType,
  documnetID,
  documentName,
  isLz,
}) => {
  // Hooks for the download button loader flag
  const [dwnBtnLoader, updateDwnBtnLoaderFlag] = useState(false);
  const [showLoader, updateShowLoader] = useState(false);
  const [LoaderMsg, updateLoaderMsg] = useState("");

  const toggleLoader = LoaderText => {
    if (LoaderText) {
      updateShowLoader(true);
      updateLoaderMsg(LoaderText);
    } else {
      updateShowLoader(false);
      updateLoaderMsg("");
    }
  };

  // Download handler in case of "SIGNER" or "REVIEWER" (ex: esign case)
  const _downloadSignedDoc = () => {
    updateDwnBtnLoaderFlag(true);
    toggleLoader(LOADING_MSG.DOCUMENT_DOWNLOADING);
    getSharedDocInPdf(docID, sharingHash)
      .then(previewContent => {
        toggleLoader();
        const newBlob = new Blob([previewContent], {
          type: "application/pdf",
        });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = data;
        link.download = `${docName}.pdf`;
        link.click();
        updateDwnBtnLoaderFlag(false);
      })
      .catch(error => {
        toggleLoader();
        console.error(
          `SharedDocumentHeader => _downloadSignedDoc => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Download Failed",
          timeout: 3000,
        });
        updateDwnBtnLoaderFlag(false);
      });
  };

  const _handleEsignDocument = () => {
    buttonClickEvent(GTM_EVENTS.SIGNINGCEREMONY_DOWNLOAD_DOC_CLICK);
    AmplitudeUtils.amplitudeLogEventLZ(EVENTS.EVENT_NAMES.CLICK_DOWNLOAD, {
      source: EVENTS.SOURCE_LZ.DOCUMENT_EDITOR,
      screen: EVENTS.SCREEN_LZ.SIGNING_PAGE,
      document_type: EVENTS.DOCUMENT_TYPE.PDF,
      document_origination: isLz
        ? EVENTS.DOCUMENT_ORIGINATION_LZ.LZ
        : EVENTS.DOCUMENT_ORIGINATION_LZ.REVV,
    });
    updateDwnBtnLoaderFlag(true);
    toggleLoader(LOADING_MSG.DOCUMENT_DOWNLOADING);
    getSignedDocumentService(documnetID, sharingHash)
      .then(response => {
        toggleLoader();
        const docMIMEType = "application/pdf";
        const file = new Blob([response], {
          type: docMIMEType,
        });
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(file, documentName);
        } else {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(file);
          link.setAttribute("download", documentName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        updateDwnBtnLoaderFlag(false);
        Toastr.showToastr({
          type: "success",
          message: "Your document has been downloaded successfully.",
          timeout: 3000,
        });
      })
      .catch(error => {
        console.error(error);
        toggleLoader();
        updateDwnBtnLoaderFlag(false);
        Toastr.showToastr({
          type: "failure",
          message: "Error while downloading",
          timeout: 3000,
        });
      });
  };

  const _otherDownloadBtn = () => (
    <div className="recipientdocheaderdownloadbutton-container">
      {docStage === "COMPLETED" &&
      (recipientType === "SIGNER" || recipientType === "REVIEWER") &&
      isSentForSignature ? (
        <span
          className={`recipientdocheader-download-button ${
            dwnBtnLoader ? "show-btn-loader" : ""
          }  ${className}`}
          data-test="recipientdocheader-download-button"
          onClick={!dwnBtnLoader ? _downloadSignedDoc : () => {}}
          tabIndex="0"
          onKeyDown={() => {}}
          role="button">
          {/* <IconDocumentDownload classNames="recipientdocheaderbuttons-icon" /> */}
          <FontAwesomeIcon
            icon={["far", "download"]}
            className="recipientdocheaderbuttons-icon"
          />
          {usedFor === "DROPDOWN" && "Download"}
          {showLoader && <LZLoader label={LoaderMsg} fullScreen />}
          {dwnBtnLoader && (
            <FontAwesomeIcon icon={["far", "spinner"]} className="fa-spin" />
          )}
        </span>
      ) : (
        <ExportDocumentBtn
          isSharedDocument={isSharedDocument}
          sharingHash={sharingHash}
          usedFor={usedFor}
          className={className}
        />
      )}
    </div>
  );
  const _esignDownloadBtn = () => (
    <span
      className={`recipientdocheader-download-button ${
        dwnBtnLoader ? "show-btn-loader" : ""
      }  ${className}`}
      data-test="recipientdocheader-download-button"
      onClick={!dwnBtnLoader ? _handleEsignDocument : () => {}}
      tabIndex="0"
      onKeyDown={() => {}}
      role="button">
      <IconDocumentDownload classNames="recipientdocheaderbuttons-icon" />
      {/* <FontAwesomeIcon
        icon={["far", "arrow-down-to-bracket"]}
        className="recipientdocheaderbuttons-icon"
      /> */}
      {usedFor === "DROPDOWN" && "Download"}
      {showLoader && <LZLoader label={LoaderMsg} fullScreen />}
      {dwnBtnLoader && (
        <FontAwesomeIcon icon={["far", "spinner"]} className="fa-spin" />
      )}
    </span>
  );
  const _downloadBtn = () => (
    <div className="recipientdocheaderdownloadbutton-container">
      {docType === "ESIGN_DOCUMENT" ? _esignDownloadBtn() : _otherDownloadBtn()}
    </div>
  );
  return isMobileView ? (
    _downloadBtn()
  ) : (
    <Tooltip
      placement={tooltipPlacement}
      align={{
        offset: [0, 4],
      }}
      overlay="Download">
      {_downloadBtn()}
    </Tooltip>
  );
};

const mapStateToProps = state => {
  const {
    document: {
      id: docID,
      name: docName,
      stage: docStage,
      is_sent_for_signature: isSentForSignature,
    } = {},
  } = state.DocumentStore;
  const { recipientType } = state.SharedDocument;
  return {
    docID,
    docName,
    docStage,
    isSentForSignature,
    recipientType,
  };
};

export default connect(mapStateToProps, null)(RecipientDocHeaderDownloadButton);
